// utils/cache.js
// Cache management utilities extracted from Profile.js

import { CACHE_DURATION } from './constants';

export const cacheManager = {
  set: (key, data) => {
    const item = { data, timestamp: Date.now() };
    try {
      sessionStorage.setItem(`profile_cache_${key}`, JSON.stringify(item));
    } catch (e) {
      console.warn('Cache storage failed:', e);
    }
  },
  
  get: (key) => {
    try {
      const item = sessionStorage.getItem(`profile_cache_${key}`);
      if (!item) return null;
      
      const parsed = JSON.parse(item);
      if (Date.now() - parsed.timestamp > CACHE_DURATION) {
        sessionStorage.removeItem(`profile_cache_${key}`);
        return null;
      }
      
      return parsed.data;
    } catch (error) {
      console.error('Cache read error:', error);
      return null;
    }
  },
  
  cclear: (key?: string) => {
    try {
      if (key) {
        sessionStorage.removeItem(`profile_cache_${key}`);
      } else {
        Object.keys(sessionStorage).forEach(k => {
          if (k.startsWith('profile_cache_')) {
            sessionStorage.removeItem(k);
          }
        });
      }
    } catch (e) {
      console.warn('Cache clear failed:', e);
    }
  }
};